import { useMutation } from 'react-query';
import { trpc } from '../../../../lib/trpc';

export default function useRemoveSpaceImageTemplateProperty() {
    return useMutation(async ({ documentId, entityId }: { documentId: number; entityId: number }) => {
        return trpc.TemplatesApi.removeSpaceImagePropertyTemplate.mutate({
            id: documentId,
            entityId,
        });
    });
}
